import React from 'react';

let changeFunction: any;
const ChangeLanguageContext = React.createContext(changeFunction);

export default ChangeLanguageContext;

